import { Accordion, AccordionTab } from "primereact/accordion";
import React, { useEffect, useRef, useState } from "react";
import ToastElement from "../../../../Components/UiComponents/ToastElement";
import { getCustomer } from "../../../../Services/customerServices";
import DropdownElement from "../../../../Components/UiComponents/DropdownElement";
import CalendarElement from "../../../../Components/UiComponents/CalendarElement";
import InputTextElementElement from "../../../../Components/UiComponents/InputTextElement";
import ButtonElement from "../../../../Components/UiComponents/ButtonElement";
import DataTable from "../../../../Components/UiComponents/DataTable";
import { useOpportunity } from "../../../../Providers/OpportunityContext";
import moment from "moment";

const ProjectTeam = (props) => {
    const [propsData, setPropsData] = useState(props);
    const [deliveryTeamRole, setDeliveryTeamRole] = useState(
        []
    );
    const [teamRole, seteamRole] = useState([]);
    const [checkedDeliveryTeamRoles, setCheckedDeliveryTeamRoles] = useState([]);
    const [days, setDays] = useState(0);
    const { globalOpportunityData, setGlobalOpportunityData } = useOpportunity();

    const toastRef = useRef();
    useEffect(() => {
        setPropsData(props);
    }, [props]);
    useEffect(() => {
        setDeliveryTeamRole(
            props.opportunityData?.delivery_team_role?.team_roles
        );
    }, [props.opportunityData.delivery_team_role]);
    useEffect(() => {
        seteamRole(propsData.deliveryTeamRoles);
    }, [propsData.deliveryTeamRoles]);
    useEffect(() => {
    }, [deliveryTeamRole]);

    useEffect(() => {
        getCustomerData();
    }, [props.customerId]);

    const deliveryTeamFieldChange = (index, selectedRow, field) => {
        var deliveryRole = deliveryTeamRole.find(
            (obj) => obj._id === selectedRow._id
        );
        if (deliveryRole) {
            setDeliveryTeamRole((prevOpp) =>
                prevOpp.map((item) =>
                    item._id === selectedRow._id
                        ? { ...item, [field]: deliveryRole.label }
                        : item
                )
            );
        }
    };
    const onDeliveryTeamDropDownChange = (e, selectedRow, field) => {
        setDeliveryTeamRole((prevOpp) =>
            prevOpp.map((item) =>
                item._id === selectedRow._id
                    ? { ...item, [field]: e.target.value.label }
                    : item
            )
        );
    };
    const onDeliveryTeamInputChange = (e, selectedRow, field) => {
        setDeliveryTeamRole((prevOpp) =>
            prevOpp.map((item) =>
                item._id === selectedRow._id
                    ? { ...item, [field]: e.target.value }
                    : item
            )
        );
    };
    useEffect(() => {
    }, [teamRole]);

    const displayDeliveryTeamRoles = (row, index) => {
        return (
            <div key={row._id}>
                <DropdownElement
                    onChange={(e) => {
                        deliveryTeamFieldChange(index, row, "role");
                        onDeliveryTeamDropDownChange(e, row, "role");
                    }}
                    id={row._id}
                    key={row._id}
                    options={(props.deliveryTeamRoles != undefined && props.deliveryTeamRoles.length > 0) ? props.deliveryTeamRoles : []}
                    value={props.deliveryTeamRoles.find((obj) => obj.label === row.role)}
                    optionLabel="label"
                    placeholder="-- Please select --"
                    className={(props.errors.includes('Delivery Team Role') && row.role == '') ? 'error-tab w-150' : 'w-150'}
                />
            </div>
        );
    };

    const displayNumRoles = (row, index) => {
        return (
            <div key={index}>
                <InputTextElementElement
                    onChange={(e) => {
                        onDeliveryTeamInputChange(e, row, "how_many_roles");
                    }}
                    id={row._id}
                    // key={row._id}
                    value={row.how_many_roles}
                    optionLabel="label"
                    placeholder=""
                    type="number"
                    className={(props.errors.includes('Delivery Team Role') && row.how_many_roles == '') ? 'error-tab w-full' : 'w-full'}
                />
            </div>
        );
    };
    const displayPercOfTime = (row, index) => {
        return (
            <div key={index}>
                <InputTextElementElement
                    onChange={(e) => {
                        deliveryTeamFieldChange(index, row, "perc_of_time");
                        onDeliveryTeamInputChange(e, row, "perc_of_time");
                    }}
                    id={row._id}
                    // key={row._id}
                    value={row.perc_of_time}
                    optionLabel="label"
                    placeholder=""
                    className={(props.errors.includes('Delivery Team Role') && row.perc_of_time == '') ? 'error-tab w-full' : 'w-full'}
                />
            </div>
        );
    };

    const parseDateString = (dateString) => {
        if (dateString) {
            const [day, month, year] = dateString.split("-")?.map(Number);
            return new Date(year, month - 1, day);
        }
    };
    const formatDate = (input) => {
        const date = input instanceof Date ? input : new Date(input);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const handleCalenderInputChange = (field1, field2, selectedRow) => {
        setDeliveryTeamRole((prevOpp) =>
            prevOpp.map((item) =>
                item._id === selectedRow._id
                    ? { ...item, [field1]: formatDate(field2) }
                    : item
            )
        );

    };

    const displayStart = (row, index) => {
        return (
            <div key={index}>
                <CalendarElement
                    id="start_date"
                    className='ml-10'
                    defaultValue={parseDateString(row.start_date)}
                    value={parseDateString(row.start_date)}
                    onChange={(value) => {
                        handleCalenderInputChange("start_date", value.value, row);
                    }}
                    maxLength="50"
                    placeholder="Date"
                    autocomplete="off"
                />
            </div>
        );
    };
    const displayEnd = (row, index) => {
        return (
            <div key={index}>
                <CalendarElement
                    id="end_date"
                    className='ml-10'
                    defaultValue={parseDateString(row.end_date)}
                    value={parseDateString(row.end_date)}
                    onChange={(value) => {
                        handleCalenderInputChange("end_date", value.value, row);
                    }}
                    maxLength="50"
                    placeholder="Date"
                    autocomplete="off"
                />
            </div>
        );
    };

    const columns = [
        {
            field: "role",
            header: `${propsData.oppProjectTeamHeaders?.find(
                (header) => header.header_name === "Delivery Team Roles"
            )?.display_name
                }`,
            body: displayDeliveryTeamRoles,
            headerClassName: "header-datatable",
            className: "row-datatable",
            style: { width: '20%' }
        },
        {
            field: "how_many_roles",
            header: `${propsData.oppProjectTeamHeaders?.find(
                (header) => header.header_name === "How Many Roles?"
            )?.display_name
                }`,
            body: displayNumRoles,
            headerClassName: "header-datatable",
            className: "row-datatable",
        },
        {
            field: "perc_of_time",
            header: `${propsData.oppProjectTeamHeaders?.find(
                (header) => header.header_name === "% of time"
            )?.display_name
                }`,
            body: displayPercOfTime,
            headerClassName: "header-datatable",
            className: "row-datatable",
        },
        {
            field: "start_date",
            header: `${propsData.oppProjectTeamHeaders?.find(
                (header) => header.header_name === "Start"
            )?.display_name
                }`,
            body: displayStart,
            headerClassName: "header-datatable",
            className: "row-datatable",
        },
        {
            field: "end_date",
            header: `${propsData.oppProjectTeamHeaders?.find(
                (header) => header.header_name === "End"
            )?.display_name
                }`,
            body: displayEnd,
            headerClassName: "header-datatable",
            className: "row-datatable",
        },
    ];

    useEffect(() => {
        setGlobalOpportunityData((prevData) => ({
            ...prevData,
            delivery_team_role: {
                ...prevData.delivery_team_role,
                team_roles: deliveryTeamRole
            },
        }));
    }, [deliveryTeamRole]);

    const getContractDuration = () => {
        let minDate = moment();
        let maxDate = moment();

        if (
            propsData.opportunityData &&
            propsData.opportunityData.delivery_team_role &&
            deliveryTeamRole
        ) {
            const teamRoles = deliveryTeamRole;
            const rolesLength = teamRoles.length;

            if (rolesLength > 1) {
                if (
                    teamRoles[rolesLength - 1].start_date === undefined ||
                    teamRoles[rolesLength - 1].end_date === undefined
                ) {
                    minDate = moment(teamRoles[0].start_date, 'DD/MM/YYYY');
                    maxDate = moment(teamRoles[0].end_date, 'DD/MM/YYYY');

                    for (let i = 0; i < rolesLength - 1; i++) {
                        const tempStart = moment(teamRoles[i].start_date, 'DD/MM/YYYY');
                        const tempEnd = moment(teamRoles[i].end_date, 'DD/MM/YYYY');
                        minDate = moment.min(tempStart, minDate);
                        maxDate = moment.max(tempEnd, maxDate);
                    }
                } else if (
                    teamRoles[rolesLength - 1].start_date !== undefined &&
                    teamRoles[rolesLength - 1].end_date !== undefined
                ) {
                    minDate = moment(teamRoles[0].start_date, 'DD/MM/YYYY');
                    maxDate = moment(teamRoles[0].end_date, 'DD/MM/YYYY');

                    for (let i = 1; i < rolesLength; i++) {
                        const tempStart = moment(teamRoles[i].start_date, 'DD/MM/YYYY');
                        const tempEnd = moment(teamRoles[i].end_date, 'DD/MM/YYYY');
                        minDate = moment.min(tempStart, minDate);
                        maxDate = moment.max(tempEnd, maxDate);
                    }
                }
            } else if (rolesLength === 1) {
                if (
                    teamRoles[0].start_date !== undefined &&
                    teamRoles[0].end_date !== undefined
                ) {
                    minDate = moment(teamRoles[0].start_date, 'DD/MM/YYYY');
                    maxDate = moment(teamRoles[0].end_date, 'DD/MM/YYYY');
                }
            }
            const calculatedDays = maxDate.diff(minDate, 'days');
            if (!isNaN(calculatedDays))
                setDays(calculatedDays);
        }
    };

    useEffect(() => {
        getContractDuration();
    }, [propsData.opportunityData, propsData.deliveryTeamRoles, deliveryTeamRole]);

    const getCustomerData = async () => {
        if (props?.customerId) {
            const customer = await getCustomer(props?.customerId);
        }
    };

    function generateRandomID() {
        const hexChars = "0123456789abcdef";
        let result = "";
        for (let i = 0; i < 24; i++) {
            result += hexChars.charAt(Math.floor(Math.random() * hexChars.length));
        }
        return result;
    }
    const addNewdeliveryTeamRole = () => {
        const newDeliveryTeamRole = {
            _id: generateRandomID(),
            end_date: propsData.opportunityData?.summary?.contract_end_date_summary?.text || "",
            how_many_roles: "",
            perc_of_time: "",
            role: "",
            start_date: propsData.opportunityData?.summary?.contract_start_date_summary?.text || "",
        };
        setDeliveryTeamRole((prevOpp) => [
            ...prevOpp,
            newDeliveryTeamRole,
        ]);
    };
    const deleteDeliveryTeamRoles = () => {
        setDeliveryTeamRole((prevData) =>
            prevData.filter(
                (item) =>
                    !checkedDeliveryTeamRoles.some((selected) => selected._id === item._id)
            )
        );
    };

    // const reorderClick = (data) => {
    //     setDeliveryTeamRole(data);
    // }

    const rowClick = (row) => {
        setCheckedDeliveryTeamRoles(row);
    };

    return (
        <>
            {propsData.pipelineTeamSections?.map((section, index) => {
                return (
                    <div key={index} className="mt-10">
                        <ToastElement ref={toastRef} />
                        <Accordion activeIndex={0}>
                            <AccordionTab
                                header={
                                    <span className="flex align-items-center justify-space-between w-full">
                                        <div>
                                            {section?.display_name}
                                        </div>
                                        <div className="flex align-items-center">
                                            Contract Duration: <span className="ml-2"> {days} Days</span>
                                        </div>
                                    </span>
                                }
                                disabled>

                                {section.section_name === "Delivery Team Roles" && (
                                    <div>
                                        <div className="col pr-0 d-flex justify-end">
                                            <div className="p-relative ml-10">
                                                <ButtonElement
                                                    className="cancel-new-button clear-filter ml-10"
                                                    type="button"
                                                    icon="pi pi-trash"
                                                    onClick={deleteDeliveryTeamRoles}
                                                />
                                                <ButtonElement
                                                    className="cancel-new-button clear-filter ml-10"
                                                    type="button"
                                                    icon="pi pi-plus"
                                                    onClick={addNewdeliveryTeamRole}
                                                />
                                            </div>
                                        </div>
                                        {propsData.oppProjectTeamTable?.find(
                                            (table) =>
                                                table.table_name === "Delivery Team"
                                        )?.status && (
                                                <div>
                                                    <DataTable
                                                        value={deliveryTeamRole}
                                                        columns={columns}
                                                        dataKey="_id"
                                                        isNotReorder={true}
                                                        rowClick={rowClick}
                                                    // reorderClick={reorderClick}
                                                    />
                                                </div>
                                            )}
                                    </div>
                                )}
                            </AccordionTab>
                        </Accordion>
                    </div>
                );
            })}
        </>
    );
};

export default ProjectTeam;